var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 128C72 114.7 82.75 104 96 104C109.3 104 120 114.7 120 128C120 141.3 109.3 152 96 152C82.75 152 72 141.3 72 128zM216 128C216 141.3 205.3 152 192 152C178.7 152 168 141.3 168 128C168 114.7 178.7 104 192 104C205.3 104 216 114.7 216 128zM264 128C264 114.7 274.7 104 288 104C301.3 104 312 114.7 312 128C312 141.3 301.3 152 288 152C274.7 152 264 141.3 264 128zM0 96C0 60.65 28.65 32 64 32H448C483.3 32 512 60.65 512 96V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V96zM32 96V416C32 433.7 46.33 448 64 448H448C465.7 448 480 433.7 480 416V96C480 78.33 465.7 64 448 64H64C46.33 64 32 78.33 32 96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.d90c46071733c8bdb27950b3cacbf9f9.svg";
export { ForwardRef as ReactComponent };